module.exports = __webpack_public_path__ + "img/vertical_4_2_8003.59f16a71.png";